class OpenHouseFilters {
	constructor() {
		this.municipalities = document.querySelector( '#municipalities' );
		this.schools = document.querySelector( '#schools' );
		this.nonce = document.querySelector( '#nonce_open_house' );

		if ( this.municipalities ) {
			this.municipalities.addEventListener( 'change', this.handleSelectChange );
		}

		if ( this.schools ) {
			this.schools.addEventListener( 'change', this.handleSelectChange );
		}
	}

	submit = () => {
		const params = new URLSearchParams( location.search );

		params.set( 'municipalities', this.municipalities.value );
		params.set( 'schools', this.schools.value );
		params.set( 'nonce', this.nonce.value );

		location.search = params.toString();
	};

	handleSelectChange = () => {
		this.submit();
	};
}

export default OpenHouseFilters;
